module.exports = __webpack_public_path__ + "img/sampleCalculator.b7a0a077.svg";